import React, { useMemo } from "react";
import {
  ObjectStatusCssClasses,
  ObjectStatusTitles,
  ObjectDeletedTitles,
  ObjectActiveTitles
} from "../../ObjectsUIHelpers";
import { FormattedMessage } from "react-intl";



const setRow = (row) => {
  if (row.fingerPrintCount === undefined || row.fingerPrintCount === null || row.fingerPrintCount === 0) {
    return (
      <span className={`label label-lg label-light-danger label-inline`} >
        {"ندارد"}
      </span >
    )
  }
  else {
    return (
      < span className={`label label-lg label-light-success label-inline`} >
        {row.fingerPrintCount}
      </span >
    )
  }
}


export const FingerPrintColumnFormatter = (cellContent, row) => setRow(row);
